/// <amd-module name="Search/Shared/Components/LoadMore/LoadMore.Props" />
export interface LoadMoreProps {
    error: boolean;
}
